import { HeaderProvider } from 'header'
import { Seo } from 'ui-components'
import { QueryProvider } from '~explore/providers/QueryProvider'
import { getCategoryTagsQueryFn } from '~explore/queries/useGetCategoryTags'
import { getPopularMapsQueryFn } from '~explore/queries/useGetPopularMaps'
import { Category_Tag_Type } from '~explore/types/__generated/gql/graphql'
import { Explore } from './Explore'

type TAppProps = Awaited<ReturnType<typeof getServerSideProps>>['props']

const App = (props: TAppProps) => {
  return (
    <QueryProvider>
      <HeaderProvider>
        <Seo />
        <Explore {...props} />
      </HeaderProvider>
    </QueryProvider>
  )
}

const getServerSideProps = async () => {
  const [
    getPopularMapsResults,
    getPrimaryTagsResults,
    getSecondaryTagsResults
  ] = await Promise.all([
    getPopularMapsQueryFn(),
    getCategoryTagsQueryFn({
      categoryTypes: [Category_Tag_Type.Primary],
      size: 3
    }),
    getCategoryTagsQueryFn({
      categoryTypes: [Category_Tag_Type.Secondary],
      size: 5
    })
  ])

  return {
    props: {
      getPopularMapsResults,
      getPrimaryTagsResults,
      getSecondaryTagsResults
    }
  }
}

export { App, getServerSideProps }
export type { TAppProps }
